import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import i18n from '@/i18n';
import { fetchDemo, refetchDemo, setDemo } from '../actions';

const refetchDemoEpic: Epic = (action$) =>
  action$.pipe(
    filter(refetchDemo.match),
    mergeMap(() => [
      setDemo({
        title: i18n.t('REFETCHING'),
        description: i18n.t('REFETCHING'),
      }),
      fetchDemo(),
    ]),
  );

export default combineEpics(refetchDemoEpic);
